export enum CreateRole {
  Default = 0,
  Admin = 100,
  UserAdmin = 125,
  QaAdmin = 150,
  SystemAdmin = 1000
}
